import type { GameQuizAnswerState, GameQuizQuestionState } from '../Model';
import { QuizAnswerTypes } from '../Model';

export class SdkQuizQuestionAnswerModel {
  public readonly id: number;
  public readonly value: string;
  public readonly description: string | undefined;
  public readonly percentageAnswered: number | undefined;

  constructor(questionState: GameQuizQuestionState, state: GameQuizAnswerState) {
    this.id = state.id;

    // Re-format the answer text for swipe questions as they're left/right instead of answer_1/answer_2
    if (questionState.answerType === QuizAnswerTypes.SWIPE) {
      this.value = state.text === 'answer_1' ? 'Left' : 'Right';
    } else {
      this.value = state.text;
    }

    this.description = state.description;
    this.percentageAnswered = state.percentage;
  }
}
